import { combineReducers } from "@reduxjs/toolkit";

import type { EditMapAction } from "domains/createMapDetail/actionTypes";
import { CreateMapTypes } from "domains/createMapDetail/actionTypes";
import type { CustomKeyIssueAction } from "domains/customKeyIssue/actionTypes";
import { CustomKeyIssueTypes } from "domains/customKeyIssue/actionTypes";
import type { CustomKeyIssueState } from "domains/customKeyIssue/types";
import { addUserOrLanguageChangeReset } from "entities/topics/reducerHelpers";

const initialState: CustomKeyIssueState = {
  topicSearch: { currentQuery: "", idsForQuery: {}, isPending: false },
  upload: { error: false, isCreateFormActive: false, isPending: false },
};

const upload = (
  state = initialState.upload,
  action: CustomKeyIssueAction | EditMapAction,
): CustomKeyIssueState["upload"] => {
  switch (action.type) {
    case CustomKeyIssueTypes.CREATE:
      return {
        ...state,
        isPending: true,
        error: false,
      };
    case CustomKeyIssueTypes.CREATE_FULFILLED:
      return {
        ...state,
        isPending: false,
        isCreateFormActive: false,
        entityId: undefined,
        error: false,
      };
    case CustomKeyIssueTypes.CREATE_REJECTED:
      return {
        ...state,
        isPending: false,
        error: true,
      };
    case CustomKeyIssueTypes.ACTIVATE_FORM:
      return {
        ...state,
        isCreateFormActive: action.meta?.isActive ?? !state.isCreateFormActive,
        entityId: action.meta?.id,
        error: false,
      };
    case CreateMapTypes.ADD_NEW_CUSTOM_KEY_ISSUE:
      return {
        ...state,
        isCreateFormActive: false,
        error: false,
      };
    default:
      return state;
  }
};

export const customKeyIssueReducer = combineReducers({
  upload: addUserOrLanguageChangeReset(upload, initialState.upload),
});
